import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWhom } from './components/ForWhom';
import { SystemStats } from './components/SystemStats';
import { Content } from './components/Content';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { MegapackDiff } from './components/MegapackDiff';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'megapack'>('megapack');
  return <div className="w-full min-h-screen" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <ProofBar data-id="element-3" />
      <Testimonials data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ForWhom data-id="element-6" />
      <SystemStats data-id="element-7" />
      <Content data-id="element-8" />
      <Bonos data-id="element-9" />
      <Comparison data-id="element-10" />
      <Urgency data-id="element-11" />
      <Pricing selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-12" />
      <MegapackDiff data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <FinalCTA selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} data-id="element-16" />
      <Footer data-id="element-17" />
      <PurchasePopup data-id="element-18" />
    </div>;
}